/* global L:false, topojson:false*/
(function () {
    'use strict';

    angular
        .module('app.region')
        .constant('leaflet', L)
        .constant('topojson', topojson);
})();
